import { CellType } from "../config/CellType";
import { CellValidator, CellValidationResult } from "./CellValidation";

const isValidNumber: CellValidator = (value: string): CellValidationResult => {
    if (value === "") return { valid: true };
    const num = parseFloat(value);
    if (isNaN(num)) return { valid: false, message: "Must be a valid number" };
    return { valid: true };
};

export const DEFAULT_CELL_TYPE_VALIDATORS: Partial<Record<CellType, CellValidator[]>> = {
    [CellType.numberInput]: [isValidNumber],
};
